module.exports = __webpack_public_path__ + "img/headphones.0799fe82.svg";